// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export const featuredWork = () => {
  const featuredWorkEl = '.featured-work-carousel';

  new Swiper(featuredWorkEl, {
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      800: {
        slidesPerView: 3,
      },
      1140: {
        slidesPerView: 5,
      },
    },
  });
};
